<ion-content>
  <div class="member">
    <div class="header d-flex justify-content-between align-items-center">
      <a (click)="close()"><i class="ti ti-arrow-left me-2"></i> Retour</a>
      <button class="button m" (click)="openRadiationModal()"
        *ngIf="authService.user.value?.role !== 'readonly' && member?.statusAsObject()?.slug === 'active' && env.config?.memberActions?.showRadiation !== false">
        <i class="ti ti-user-x me-2"></i> Demande de radiation
      </button>
    </div>
    <div class="content">
      <div class="d-flex flex-row align-items-center justify-content-between">
        <div class="profile d-flex flex-row align-items-center">
          <app-user-initials [member]="member" size="lg"></app-user-initials>
        </div>
        <!--        <div class="actions d-flex flex-row align-items-center gap-2" *ngIf="authService.user.value?.role !== 'readonly'">-->
        <!--          <button class="button primary icon-start" (click)="sendMail()"><i class="ti ti-mail"></i> Email</button>-->
        <!--          <app-dropdown>-->
        <!--            <div class="dropdown-header" #dropHeader>-->
        <!--              <div class="button m icon-end">Actions<i class="ti ti-chevron-down"></i></div>-->
        <!--            </div>-->
        <!--            <div class="dropdown-content" #dropContent>-->
        <!--              <div class="content">-->
        <!--                <div class="actions">-->
        <!--                  <div class="item close" (click)="shareDocuments()">-->
        <!--                    <i class="ti ti-paperclip me-3"></i> Envoyer un document-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;-->
        <!--                  <div class="item close">-->
        <!--                    <i class="ti ti-x me-3"></i> Radiation-->
        <!--                  </div>-->
        <!--                  &ndash;&gt;-->
        <!--                </div>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </app-dropdown>-->
        <!--        </div>-->
      </div>
      <div class="tab-selector d-flex flex-row mt-5">
        <span class="selector" *ngIf="env.config?.memberDetails?.panels?.contract"
          [ngClass]="{ active: tab === 'contract' }" (click)="selectTab('contract')">Contrat</span>
        <span class="selector" *ngIf="env.config?.memberDetails?.panels?.informations"
          [ngClass]="{ active: tab === 'informations' }" (click)="selectTab('informations')">Informations</span>
        <span class="selector" *ngIf="env.config?.memberDetails?.panels?.documents"
          [ngClass]="{ active: tab === 'documents' }" (click)="selectTab('documents')">Documents</span>
        <!--<span class="selector" [ngClass]="{active: tab === 'forms'}" (click)="selectTab('forms')">Formulaires</span>-->
      </div>
      <!-- Contract -->
      <div id="contract" class="tab" *ngIf="
          tab === 'contract' && env.config?.memberDetails?.panels?.contract
        ">
        <form *ngIf="contractForm" [formGroup]="contractForm" class="d-flex flex-column w-100 gap-3">
          <h3>Contrat</h3>
          <div class="d-flex flex-column gap-2 form-group w-100 mt-3">
            <label>Nom du contrat santé</label>
            <app-editable-input control="regime" [form]="contractForm" [readonly]="true"></app-editable-input>
          </div>
          <div class="row">
            <div class="col-6 d-flex flex-column gap-2">
              <label>Date de début du contrat</label>
              <app-editable-input control="startDate" [form]="contractForm" [readonly]="true"></app-editable-input>
            </div>
            <div class="col-6 d-flex flex-column gap-2">
              <label>Date de fin du contrat</label>
              <app-editable-input control="endDate" [form]="contractForm" [readonly]="true"></app-editable-input>
            </div>
          </div>
          <div class="d-flex flex-row gap-3 w-100">
            <div class="d-flex flex-column gap-2 form-group w-50">
              <label>Statut</label>
              <app-status-badge [member]="member"></app-status-badge>
            </div>
            <div class="d-flex flex-column gap-2 form-group w-50"
              *ngIf="env.config?.memberDetails?.showTeletransmission">
              <label>Télétransmission</label>
              <span class="tag" [ngClass]="{ success: member?.teletransmission?.code }">
                <i class="bi bi-{{
                    member?.teletransmission?.code
                      ? 'check2'
                      : 'question-circle'
                  }} me-2"></i>
                {{
                member?.teletransmission?.code
                ? "Activée"
                : "Information non disponible"
                }}
              </span>
            </div>
          </div>
          <div class="d-flex flex-column gap-2 form-group w-100" *ngIf="env.config?.memberDetails?.showCaisse">
            <label>CPAM de rattachement</label>
            <app-editable-input control="cpam" [form]="contractForm" [readonly]="true"></app-editable-input>
          </div>
          <ng-container *ngIf="canShowBeneficiaires">
            <div class="d-flex justify-content-between align-items-center mt-3">
              <h3>Bénéficiaires</h3>
              <button class="button m" (click)="manageBeneficiaries()" *ngIf="
                  env.config?.memberDetails?.showBeneficiaryManagement &&
                  authService.user.value?.role !== 'readonly'
                ">
                <i class="ti ti-users-group me-2"></i> Gérer les bénéficiaires
              </button>
            </div>
            <em *ngIf="beneficiaries.length === 0" class="text-muted">
              Aucun bénéficiaire enregistré
            </em>
            <table class="table rounded shadowed" *ngIf="beneficiaries.length > 0">
              <thead>
                <tr>
                  <th>Nom</th>
                  <th>Date de naissance</th>
                  <th>Début</th>
                  <th>Fin</th>
                  <th>Type</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let c of beneficiaries; let i = index">
                  <td>
                    {{ c.lastname }} {{ c.firstname }}
                    <ng-container *ngIf="c.birthname && c.birthname !== c.lastname">&nbsp;né•e {{ c.birthname
                      }}</ng-container>
                  </td>
                  <td>{{ c.birthdate }}</td>
                  <td>{{ c.startDate }}</td>
                  <td>{{ c.endDate }}</td>
                  <td>{{ c.typeFormatted() }}</td>
                </tr>
              </tbody>
            </table>
          </ng-container>
          <ng-container *ngIf="env.config?.memberDetails?.showCotisations">
            <h3 class="mt-3">Cotisations</h3>
            <table class="table rounded shadowed">
              <thead>
                <tr>
                  <th>Libellé</th>
                  <th>Montant</th>
                  <th>Date d'appel</th>
                  <th class="text-end">Statut</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let c of cotisations; let i = index">
                  <td>{{ c.label }}</td>
                  <td>
                    {{ c.amount | currency : "EUR" : "symbol" : "1.2-2" }}
                  </td>
                  <td>{{ c.dueAt | date : "dd/MM/yyyy" }}</td>
                  <td class="text-end">
                    <span class="tag" [ngClass]="{
                        success: c.status === 'paid',
                        error: c.status === 'unpaid'
                      }">{{ c.statusFormatted }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </ng-container>
        </form>
        <div class="py-5 d-flex flex-column justify-content-center align-items-center gap-3 w-100"
          *ngIf="!contractForm">
          <div *ngFor="let i of [0, 1, 2, 3, 4, 5, 6, 7]" class="w-100">
            <ion-skeleton-text style="width: 100%; height: 15px" [animated]="true"></ion-skeleton-text>
          </div>
        </div>
      </div>
      <!-- Informations -->
      <div id="informations" class="tab" *ngIf="
          tab === 'informations' &&
          env.config?.memberDetails?.panels?.informations
        ">
        <form *ngIf="informationsForm" [formGroup]="informationsForm" class="d-flex flex-column w-100 gap-3">
          <h3>Informations personnelles</h3>
          <div class="d-flex flex-column gap-2 form-group w-100 mt-3">
            <label>Numéro de sécurité sociale</label>
            <app-editable-input control="socialSecurityNumber" [form]="informationsForm"
              [readonly]="true"></app-editable-input>
          </div>
          <div class="d-flex flex-column gap-2 form-group w-100">
            <label>Date de naissance</label>
            <app-editable-input control="birthdate" [form]="informationsForm" [readonly]="true"></app-editable-input>
          </div>
          <ng-container *ngIf="env.config?.memberDetails?.showEmails">
            <h3 class="mt-3">Coordonnées</h3>
            <div class="d-flex flex-column gap-2 form-group w-100 mt-3">
              <label>Courriel</label>
              <app-editable-input type="email" control="mail" [form]="informationsForm"
                (changed)="onMemberUpdate('email')"></app-editable-input>
            </div>
          </ng-container>
          <ng-container *ngIf="env.config?.memberDetails?.showMobileEdit">
            <div class="d-flex flex-column gap-2 form-group w-100 mt-3">
              <label>Téléphone portable</label>
              <app-editable-input type="tel" control="mobile" [form]="informationsForm"
                (changed)="onMemberUpdate('mobile')"></app-editable-input>
            </div>
          </ng-container>
          <!--          <div class="row">-->
          <!--            <div class="col-6 d-flex flex-column gap-2">-->
          <!--              <label>Téléphone fixe</label>-->
          <!--              <app-editable-input type="tel" control="phone" [form]="informationsForm" (changed)="onMemberUpdate('phone')"></app-editable-input>-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="d-flex flex-column gap-2 form-group w-100">
            <label>Adresse</label>
            <app-editable-input control="street" [form]="informationsForm" [readonly]="true"></app-editable-input>
          </div>
          <div class="row">
            <div class="col-6 d-flex flex-column gap-2">
              <label>Code postal</label>
              <app-editable-input type="zip" control="zipCode" [form]="informationsForm"
                [readonly]="true"></app-editable-input>
            </div>
            <div class="col-6 d-flex flex-column gap-2">
              <label>Commune</label>
              <app-editable-input control="city" [form]="informationsForm" [readonly]="true"></app-editable-input>
            </div>
          </div>
        </form>
        <div class="py-5 d-flex flex-column justify-content-center align-items-center gap-3 w-100"
          *ngIf="!informationsForm">
          <div *ngFor="let i of [0, 1, 2, 3, 4, 5, 6, 7]" class="w-100">
            <ion-skeleton-text style="width: 100%; height: 10px" [animated]="true"></ion-skeleton-text>
          </div>
        </div>
      </div>
      <!-- Documents tab : we display share where either source or target is the member -->
      <div id="documents" class="d-flex flex-column tab" *ngIf="
          tab === 'documents' && env.config?.memberDetails?.panels?.documents
        ">
        <div class="documents d-flex flex-column gap-5">
          <div class="d-flex flex-column gap-2 form-group w-100 my-3">
            <label>Dernière connexion au portail d'ajout de documents</label>
            <p>{{ member?.lastAccessFormatted() }}</p>
          </div>

          <ng-container *ngIf="!shares else shareList">
            <div class="py-5 d-flex flex-column justify-content-center align-items-center gap-3 w-100">
              <div *ngFor="let i of [0, 1, 2, 3, 4, 5, 6, 7]" class="w-100">
                <ion-skeleton-text style="width: 100%; height: 15px" [animated]="true"></ion-skeleton-text>
              </div>
            </div>
          </ng-container>
          <ng-template #shareList>
            <ng-container *ngIf="shares.length === 0; else documentList">
              <span class="fst-italic text-muted">Aucun document disponible</span>
            </ng-container>
            <ng-template #documentList>
              <table class="table rounded mt-3">
                <thead>
                  <tr>
                    <th>Envoyé par</th>
                    <th>Message</th>
                    <th>Date</th>
                    <th>Documents</th>
                    <th class="dropdown-column"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let s of shares; let i = index">
                    <td>{{ ((s.source === 'enterprise' ? s.enterpriseName : s.insuredName) || 'Inconnu') | ellipse: 20
                      }}</td>
                    <td>{{ s.message || 'Aucun message' | ellipse: 20 }}</td>
                    <td>{{ s.createdAtFormatted() }}</td>
                    <td>
                      <span class="chip">
                        {{ s.documents.length }}
                      </span>
                    </td>
                    <td>
                      <button class="button m icon transparent" (click)="seeShare(s)">
                        <i class="ti ti-eye"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-template>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</ion-content>
